import React, { useContext, useEffect, useState } from "react";
import { BsGraphUpArrow } from "react-icons/bs";
import { IoMdOpen } from "react-icons/io";
import BasicModal from "../Modals/BasicModal";
import { fetchPsfSalesAllYearData, fetchPsfSalesData } from "./psfSalesServiceKpi";
import { FilterContext } from "../../context/Filter";
import PsfSalesScoreGraph from "./psfSalesGraph/PsfSalesScoreGraph";
import PsfSalesCustomerEffort from "./psfSalesGraph/PsfSalesCustomerEffortGraph";
import PsfSalesDissatisfactionGraph from "./psfSalesGraph/psfSalesDissatisfactionGraph";

const PsfSalesCard = () => {
  const [psfServiceModal, setPsfServiceModal] = useState(false);
  const [customerEffortModal, setCustomerEffortModal] = useState(false);
  const [dissatisfactionModal, setDissatisfactionModal] = useState(false);
  const { arn: parArn, childArn } = useContext(FilterContext);
  const [psfSalesData, setPsfSalesData] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchPsfSales = async () => {
    setLoading(true);
    try {
      const response = await fetchPsfSalesData(parArn, childArn);
      setPsfSalesData(response);
    } catch (error) {
      console.error("Error fetching all years data:", error);
      setPsfSalesData(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    fetchPsfSales();
  }, [])
  return (
    <div className="rounded-md w-[350px] h-[160px] border p-2 flex flex-col gap-4">
      <div className="flex gap-2 items-center">
        <div className="p-2 bg-blue-500 rounded-md text-white font-semibold w-8">
          <BsGraphUpArrow />
        </div>
        <p className="text-md font-semibold">PSF Sales {`(${psfSalesData?.key})`}</p>
      </div>

      <div className="flex items-center justify-center gap-4">
        {/* PSF Score */}
        <div className="flex flex-col justify-center items-center gap-2">
          <p className="text-sm text-gray-500">PSF Score</p>
          <p className="font-semibold">{psfSalesData?.psf || 0}%</p>
          <BasicModal
            open={psfServiceModal}
            handleOpenModal={() => setPsfServiceModal(true)}
            handleCloseModal={() => setPsfServiceModal(false)}
            title="PSF Score"
            trigger={
              <div
                className="w-8 text-white p-2 rounded-md bg-blue-500 cursor-pointer"
                onClick={() => setPsfServiceModal(true)}
              >
                <IoMdOpen />
              </div>
            }
          >
            <PsfSalesScoreGraph />
          </BasicModal>
        </div>

        {/* Customer Effort */}
        <div className="flex flex-col justify-center items-center gap-2">
          <p className="text-sm text-gray-500">Customer Effort</p>
          <p className="font-semibold">{psfSalesData?.ces || 0}%</p>
          <BasicModal
            open={customerEffortModal}
            handleOpenModal={() => setCustomerEffortModal(true)}
            handleCloseModal={() => setCustomerEffortModal(false)}
            title="Customer Effort"
            trigger={
              <div
                className="w-8 text-white p-2 rounded-md bg-blue-500 cursor-pointer"
                onClick={() => setCustomerEffortModal(true)}
              >
                <IoMdOpen />
              </div>
            }
          >
            <PsfSalesCustomerEffort />
          </BasicModal>
        </div>

        {/* Dissatisfaction */}
        <div className="flex flex-col justify-center items-center gap-2">
          <p className="text-sm text-gray-500">Dissatisfaction</p>
          <p className="font-semibold">{psfSalesData?.dssat || 0}%</p>
          <BasicModal
            open={dissatisfactionModal}
            handleOpenModal={() => setDissatisfactionModal(true)}
            handleCloseModal={() => setDissatisfactionModal(false)}
            title="Dissatisfaction"
            trigger={
              <div
                className="w-8 text-white p-2 rounded-md bg-blue-500 cursor-pointer"
                onClick={() => setDissatisfactionModal(true)}
              >
                <IoMdOpen />
              </div>
            }
          >
            <PsfSalesDissatisfactionGraph />
          </BasicModal>
        </div>
      </div>
    </div>
  );
};

export default PsfSalesCard;
